import React from 'react';
import Helmet from 'react-helmet';

const MetaInfo = (props) => {

    return (
        <>
            {props.lang !== 'fr' ?
                <Helmet>
                    <title>Our Chicken Guarantee</title>
                    <meta name="description" content="At A&W, we only serve chicken that’s raised without the use of antibiotics and fed a grain-based diet without animal by-products." />
                </Helmet>
            :
                <Helmet>
                    <title>La garantie sur notre poulet</title>
                    <meta name="description" content="Chez A&W, nous servons uniquement du poulet de grain élevé sans antibiotiques et sans aucun sous-produit animal." />
                </Helmet>
            }
        </>
    )
}
export default MetaInfo;